import { render, staticRenderFns } from "./MapeoRespuesta.vue?vue&type=template&id=54740f0a&scoped=true&"
import script from "./MapeoRespuesta.vue?vue&type=script&lang=ts&"
export * from "./MapeoRespuesta.vue?vue&type=script&lang=ts&"
import style0 from "./MapeoRespuesta.vue?vue&type=style&index=0&id=54740f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54740f0a",
  null
  
)

export default component.exports